import { useState } from "react";
import { dishes, categories, type Dish } from "../../../mocks/home";

interface MenuDiscoveryProps {
  selectedIds: string[];
  onToggle: (id: string) => void;
}

const days = ["Bugün", "Yarın"];

export default function MenuDiscovery({ selectedIds, onToggle }: MenuDiscoveryProps) {
  const [activeDay, setActiveDay] = useState("Bugün");
  const [activeCategory, setActiveCategory] = useState("ana-yemek");

  const filtered = dishes.filter((d) => d.category === activeCategory);

  return (
    <div>
      {/* Day selector */}
      <div className="flex justify-start lg:justify-center">
        <div className="inline-flex bg-background-100 rounded-full px-1 py-1">
          {days.map((day) => (
            <button
              key={day}
              onClick={() => setActiveDay(day)}
              className={`px-6 py-2 rounded-full text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                activeDay === day
                  ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              {day}
            </button>
          ))}
        </div>
      </div>

      {/* Category chips */}
      <div className="mt-6 flex flex-wrap gap-2">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition-colors whitespace-nowrap cursor-pointer ${
              activeCategory === cat.id
                ? "bg-primary-500 border-primary-500 text-background-50 dark:text-foreground-950"
                : "bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300"
            }`}
          >
            <i className={`${cat.icon} text-base`}></i>
            {cat.name}
          </button>
        ))}
      </div>

      {/* Dish cards */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        {filtered.map((dish: Dish) => {
          const selected = selectedIds.includes(dish.id);
          return (
            <div
              key={dish.id}
              className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={dish.image}
                  alt={dish.name}
                  title={`${dish.name} - Meliha Sultan Ev Yemekleri`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 right-3 bg-background-50/90 text-foreground-700 text-[11px] font-semibold px-2.5 py-1 rounded-full">
                  {dish.calories} kcal
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {dish.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {dish.description}
                </p>
                <button
                  onClick={() => onToggle(dish.id)}
                  className={`mt-4 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-bold transition-all whitespace-nowrap cursor-pointer ${
                    selected
                      ? "bg-primary-100 text-primary-700 border border-primary-300"
                      : "bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600"
                  }`}
                >
                  {selected ? (
                    <>
                      <i className="ri-check-line"></i>
                      MENÜNDE
                    </>
                  ) : (
                    <>
                      <i className="ri-add-line"></i>
                      MENÜME EKLE
                    </>
                  )}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}